import React, { useState, useEffect } from 'react'
import './index.scss'
import {
    Input,
    Card,
    Avatar,
    Skeleton
} from 'antd';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPollH,
    faTimesCircle,
    faArrowCircleDown,
    faSync,
    faSlidersH,
    faBalanceScale,
} from '@fortawesome/free-solid-svg-icons';
import Select from "react-select";
import TagDuoTone from "../../../iconComponent/TagDuoTone";
import { StaticImage } from '../../../../utils/image';
import { ConvertDateShort } from '../../../../utils/date';
import { checkComplete, checkLeftTime, checkLeftTimeIcon, checkLeftTimeStatus } from '../../../../utils';
import ProgressBar from "../ProgressBar";
import { useHistory } from 'react-router-dom';
import { encodeBase64 } from '../../../../utils/convertBase64';
const { Search } = Input;

const listTextOption = [
    { value: '', label: "ทั้งหมด" },
    { value: "O", label: "เปิดรับฟัง" },
    { value: "I", label: "ปิดรับฟัง" },
];



const SurveyCardItem = ({ survey, law_group, entitys, project }) => {
    const history = useHistory();
    const [isCollapse, setIsCollapse] = useState(false);
    const renderImageLawGroup = (item) => {
        let law = "";
        if (item.law_group_id) {
            const split = item.law_group_id.split(",");
            law = law_group.find((x) => x.lawgroup_id == split[0]);
        }

        return (
            <div className="law-group-container d-flex-center">
                <div className="d-flex-center">
                    {law && law.image ? (
                        <Avatar
                            alt="image of law group"
                            className="avatar-object-contain"
                            size={{
                                xs: 75,
                                sm: 75,
                                md: 75,
                                lg: 75,
                                xl: 75,
                                xxl: 75,
                            }}
                            style={{
                                height: 75,
                                width: 75,
                            }}
                            // shape={'circle'}
                            src={law.image}
                        />
                    ) : (
                        <Skeleton.Button active={true} size={100} shape={"circle"} />
                    )}
                </div>
            </div>
        );
    };
    const renderLawGroupText = (item) => {
        let law = "ไม่ได้ระบุ";
        if (item.law_group_id) {
            const split = item.law_group_id.split(",");
            law = law_group.filter((x) => split.includes(x.lawgroup_id.toString()));
            law = law.length > 0 ? law.map(x => x.lawgroup_name).join(',') : "-";
        }

        return (
            <div
                className="d-flex discuss-container"
                style={{ marginRight: 15 }}
            >
                <img
                    src={StaticImage("/images/icon/books-duotone-1-copy.svg")}
                    style={{ marginRight: 5 }}
                    alt="webboard"
                    height={24}
                />
                <label className="lawgroup-text" style={{ color: "#333" }}>
                    {law}
                </label>
            </div>
        );
    };
    const renderAnswerCount = (survey) => {
        let answer_count = survey.answer_count ?? 0;
        return (
            <div className="d-flex discuss-container" style={{ marginRight: 15 }}>
                <div className="badge-answer">{answer_count}</div>
            </div>
        );
    };
    const renderPublishNo = (survey) => {
        return (
            <div className="d-flex discuss-container">
                <img
                    src={StaticImage("/images/icon/pen-nib-duotone.svg")}
                    style={{ marginRight: 5 }}
                    height={24}
                    alt="public-no"
                />
                <div className="d-flex" style={{ alignItems: 'center' }}>
                    <span>ครั้งที่</span>
                    <div className="badge-public">{survey.publish_no}</div>
                </div>
            </div>
        );
    };

    const collapse = (e, item) => {
        e.stopPropagation();
        setIsCollapse(!isCollapse);
    };

    const navigate = (survey_id) => {
        history.push(`/listeningDetail?survey_id=${encodeBase64(survey_id)}`);
    }

    const renderFavorite = (survey) => {
        return (
            survey.is_like === true ? (
                <img
                    height={32}
                    width={32}
                    src={StaticImage(
                        "/images/icon/header/heart-circle-duotone-2-active.svg"
                    )}
                    alt="favorite"
                />
            ) : (
                <img
                    height={32}
                    width={32}
                    className="cursor-pointer"
                    onMouseOver={(e) =>
                    (e.currentTarget.src = StaticImage(
                        "/images/icon/header/heart-circle-duotone-2-active.svg"
                    ))
                    }
                    onMouseOut={(e) =>
                    (e.currentTarget.src = StaticImage(
                        "/images/icon/header/heart-circle-duotone-2.svg"
                    ))
                    }
                    src={StaticImage(
                        "/images/icon/header/heart-circle-duotone-2.svg"
                    )}
                    alt="favorite"
                />
            )
        );
    }

    const renderDate = () => {
        return (
            <div className="d-flex-align-center" style={{ marginRight: 20 }}>
                <img
                    src={StaticImage(checkLeftTimeIcon(survey) ? "/images/icon/vote-yea-duotone.svg" : "/images/icon/vote-nay-duotone.svg")}
                    style={{ marginRight: 5 }}
                    height={16}
                    alt="public-no"
                />
                <div className="d-flex" style={{ alignItems: 'center' }}>
                    <span>
                        {`${ConvertDateShort(survey.start_date, "DD MMM YY")} - ${ConvertDateShort(survey.end_date, "DD MMM YY")}`}
                    </span>
                </div>
            </div>
        );
    };
    const renderStatus = () => {
        return (
            checkLeftTimeStatus(survey)
        );
    };

    return (
        <section style={{ marginBottom: 20 }}>
            <div className="survey-card" onClick={() => navigate(survey.survey_id)}>
                <div className="column1">
                    {renderImageLawGroup(survey)}
                    <div
                        className="d-flex-center"
                        style={{ marginTop: 20, minWidth: 170 }}
                    >
                        {survey.agency_short && (
                            <div
                                className="organize-container"
                                style={{ margin: 0, maxWidth: 100 }}
                            >
                                <img
                                    alt="agency_image"
                                    src={survey.agency_image_uploaded ?? survey.agency_image}
                                    className="logo"
                                    oncontextmenu="return false;"
                                    onError={(i) => (i.target.style.display = "none")}
                                />
                                <label style={{ paddingLeft: "2px" }}>
                                    {survey.agency_short ?? survey.agency_abbrv}
                                </label>
                            </div>
                        )}
                    </div>
                    <div className="project-type" style={{ marginTop: 20 }}>
                        <TagDuoTone />
                        <span>
                            {survey.survey_type_name}
                        </span>
                    </div>
                </div>
                <div className="column2">
                    <div className='d-flex-center gap-x-2 flex'>
                        <label className="title flex-1">{survey.short_project_name ?? survey.project_name}</label>
                        {survey.remark_warning && <div className="relative group">
                            {/* Icon Warning */}
                            <span className="text-yellow-500 text-3xl cursor-pointer">
                                ⚠️
                            </span>

                            {/* Tooltip : show on hover */}

                            <div className="absolute hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap z-10 left-1/2 -translate-x-1/2 mt-1">
                                {survey.remark_warning}
                            </div>
                        </div>
                        }
                    </div>
                    <label className="description">
                        {survey.short_survey_name ?? survey.survey_name}
                    </label>

                    <div className="webboard-row">
                        {renderLawGroupText(survey)}
                        <div className="d-flex discuss-container">
                            <img
                                src={StaticImage("/images/icon/users-class-light.svg")}
                                style={{ marginRight: 10 }}
                                alt="webboard"
                            />
                            <label style={{ color: "#488345" }}>
                                ร่วมเสนอ
                            </label>
                        </div>
                        {renderAnswerCount(survey)}
                        {renderPublishNo(survey)}
                        {(survey.created_agency_id == 403) &&
                            <div className='flex ml-4 h-fit gap-x-2 py-1 items-center px-4 text-[#756039] bg-[#F7F1DE] rounded-xl'>
                                <img
                                    src={StaticImage("/images/icon_v3/yellow/building-columns-duotone.svg")}
                                    width={16}
                                    height={16}
                                    alt="webboard"
                                />
                                <span>สคก. สร้างการรับฟัง</span>
                            </div>
                        }
                    </div>
                    <div className="progressbar-row">
                        <div style={{ display: "flex", flex: 1, paddingRight: 7.5 }}>
                            {checkLeftTimeIcon(survey) ? <>
                                <img
                                    src={StaticImage(checkLeftTimeIcon(survey) ? "/images/icon/vote-yea-duotone.svg" : "/images/icon/vote-nay-duotone.svg")}
                                    style={{ marginRight: 10 }}
                                    height={20}
                                    alt="public-no"
                                />
                                <span style={{ fontSize: 16 }}>
                                    {ConvertDateShort(survey.start_date, "DD MMM YY")}
                                </span>
                                <section
                                    className="progress-list-filter"
                                    style={{ width: "100%", maxWidth: 400 }}
                                >
                                    <ProgressBar
                                        bgcolor={survey.date_balance > 7 ? "#387436" : "#f96b57"}
                                        bgContainerColor={
                                            survey.date_balance > 7 ? "#e4e8f0" : "#e4e8f0"
                                        }
                                        leftTime={checkLeftTime(survey)}
                                        completed={checkComplete(survey)}
                                    />
                                </section>
                                <span>
                                    <span style={{ fontSize: 16 }}>
                                        {ConvertDateShort(survey.end_date, "DD MMM YY")}
                                    </span>
                                </span>
                            </> :
                                <>
                                    {renderDate()}
                                    {renderStatus()}
                                </>}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}



export default SurveyCardItem;